import script from "./UsersContentByCompany.vue?vue&type=script&setup=true&lang=ts"
export * from "./UsersContentByCompany.vue?vue&type=script&setup=true&lang=ts"

import "./UsersContentByCompany.vue?vue&type=style&index=0&id=2f452ee6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f452ee6"]])

export default __exports__